module.exports = __webpack_public_path__ + "cab00f5332259e22f831a909ca0dc71b.MP3";